<template>
  <div id="app">

    <md-snackbar md-position="center" :md-duration="Infinity" :md-active.sync="showMessage">
      <span>{{ $t(message, messageValue) }}</span>
       <md-button class="snack-button" @click="showMessage = false">{{$t('close')}}</md-button>
    </md-snackbar>

    <div v-show="loading" class="loading-full lds-ring"><div></div><div></div><div></div><div></div></div>

    <router-view v-show="!loading" v-if="showFullScreen"></router-view>

    <admin-menu v-show="!loading" v-else>
      <router-view class="layout-width"></router-view>
    </admin-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AdminMenu from './components/AdminMenu'

export default {
  name: 'app',
  components: {
    AdminMenu
  },
  computed: {
    ...mapState('Global', ['message', 'loading', 'messageValue']),
    showMessage: {
      get() {
        return this.$store.getters['Global/showMessage']
      },
      set(value) {
        this.$store.dispatch('Global/hideMessage')
      }
    },
    showFullScreen() {
      return this.$route.meta.fullScreen
    }
  }
}
</script>

<style lang="scss" scoped>
  #app {

    text-align: center;
    height: 100vh;
  }

  ::v-deep .snack-button{
    min-width: 75px;
    color: #ffffff !important;

  }

  .md-snackbar{
    max-height: unset;
  }

  .corporate-notice{
    white-space: pre-wrap;
  }

</style>
